var items = {
  "block.minecraft.air": "không khí",
  "block.minecraft.stone": "đá",
  "block.minecraft.granite": "đá hoa cương",
  "block.minecraft.polished_granite": "đá hoa cương được đánh bóng",
  "block.minecraft.diorite": "đá diorit",
  "block.minecraft.polished_diorite": "đá diorit được đánh bóng",
  "block.minecraft.andesite": "đá andesit",
  "block.minecraft.polished_andesite": "đá andesit được đánh bóng",
  "block.minecraft.grass_block": "khối cỏ",
  "block.minecraft.dirt": "đất",
  "block.minecraft.coarse_dirt": "đất thô",
  "block.minecraft.podzol": "đất podzol",
  "block.minecraft.crimson_nylium": "khuẩn dị thể đỏ thẫm",
  "block.minecraft.warped_nylium": "khuẩn dị thể kì dị",
  "block.minecraft.cobblestone": "đá cuội",
  "block.minecraft.oak_planks": "ván gỗ sồi",
  "block.minecraft.spruce_planks": "ván gỗ vân sam",
  "block.minecraft.birch_planks": "ván gỗ bạch dương",
  "block.minecraft.jungle_planks": "ván gỗ rừng",
  "block.minecraft.acacia_planks": "ván gỗ xiêm gai",
  "block.minecraft.dark_oak_planks": "ván gỗ sồi sẫm",
  "block.minecraft.crimson_planks": "ván đỏ thẫm",
  "block.minecraft.warped_planks": "ván kì dị",
  "block.minecraft.oak_sapling": "chồi cây sồi",
  "block.minecraft.spruce_sapling": "chồi cây vân sam",
  "block.minecraft.birch_sapling": "chồi cây bạch dương",
  "block.minecraft.jungle_sapling": "chồi cây rừng",
  "block.minecraft.acacia_sapling": "chồi cây xiêm gai",
  "block.minecraft.dark_oak_sapling": "chồi cây sồi sẫm",
  "block.minecraft.bedrock": "đá nền",
  "block.minecraft.sand": "cát",
  "block.minecraft.red_sand": "cát đỏ",
  "block.minecraft.gravel": "sỏi",
  "block.minecraft.gold_ore": "quặng vàng",
  "block.minecraft.iron_ore": "quặng sắt",
  "block.minecraft.coal_ore": "quặng than",
  "block.minecraft.nether_gold_ore": "quặng vàng nether",
  "block.minecraft.oak_log": "thân cây sồi",
  "block.minecraft.spruce_log": "thân cây vân sam",
  "block.minecraft.birch_log": "thân cây bạch dương",
  "block.minecraft.jungle_log": "thân cây rừng",
  "block.minecraft.acacia_log": "thân cây xiêm gai",
  "block.minecraft.dark_oak_log": "thân cây sồi sẫm",
  "block.minecraft.crimson_stem": "cuống đỏ thẫm",
  "block.minecraft.warped_stem": "cuống kì dị",
  "block.minecraft.stripped_oak_log": "thân cây sồi đã cạo vỏ",
  "block.minecraft.stripped_spruce_log": "thân cây vân sam đã cạo vỏ",
  "block.minecraft.stripped_birch_log": "thân cây bạch dương đã cạo vỏ",
  "block.minecraft.stripped_jungle_log": "thân cây rừng đã cạo vỏ",
  "block.minecraft.stripped_acacia_log": "thân cây xiêm gai đã cạo vỏ",
  "block.minecraft.stripped_dark_oak_log": "thân cây sồi sẫm đã cạo vỏ",
  "block.minecraft.stripped_crimson_stem": "cuống đỏ thẫm đã cạo vỏ",
  "block.minecraft.stripped_warped_stem": "cuống kì dị đã cạo vỏ",
  "block.minecraft.stripped_oak_wood": "gỗ sồi đã cạo vỏ",
  "block.minecraft.stripped_spruce_wood": "gỗ vân sam đã cạo vỏ",
  "block.minecraft.stripped_birch_wood": "gỗ bạch dương đã cạo vỏ",
  "block.minecraft.stripped_jungle_wood": "gỗ rừng đã cạo vỏ",
  "block.minecraft.stripped_acacia_wood": "gỗ xiêm gai đã cạo vỏ",
  "block.minecraft.stripped_dark_oak_wood": "gỗ sồi sẫm đã cạo vỏ",
  "block.minecraft.stripped_crimson_hyphae": "sợi nấm đỏ thẫm đã cạo vỏ",
  "block.minecraft.stripped_warped_hyphae": "sợi nấm kì dị đã cạo vỏ",
  "block.minecraft.oak_wood": "gỗ sồi",
  "block.minecraft.spruce_wood": "gỗ vân sam",
  "block.minecraft.birch_wood": "gỗ bạch dương",
  "block.minecraft.jungle_wood": "gỗ rừng",
  "block.minecraft.acacia_wood": "gỗ xiêm gai",
  "block.minecraft.dark_oak_wood": "gỗ sồi sẫm",
  "block.minecraft.crimson_hyphae": "sợi nấm đỏ thẫm",
  "block.minecraft.warped_hyphae": "sợi nấm kì dị",
  "block.minecraft.oak_leaves": "lá sồi",
  "block.minecraft.spruce_leaves": "lá vân sam",
  "block.minecraft.birch_leaves": "lá bạch dương",
  "block.minecraft.jungle_leaves": "lá rừng",
  "block.minecraft.acacia_leaves": "lá xiêm gai",
  "block.minecraft.dark_oak_leaves": "lá sồi sẫm",
  "block.minecraft.sponge": "miếng bọt biển",
  "block.minecraft.wet_sponge": "miếng bọt biển ướt",
  "block.minecraft.glass": "thủy tinh",
  "block.minecraft.lapis_ore": "quặng ngọc lưu ly",
  "block.minecraft.lapis_block": "khối ngọc lưu ly",
  "block.minecraft.dispenser": "máy phân phát",
  "block.minecraft.sandstone": "cát kết",
  "block.minecraft.chiseled_sandstone": "cát kết được đục",
  "block.minecraft.cut_sandstone": "cát kết được cắt",
  "block.minecraft.note_block": "khối nốt nhạc",
  "block.minecraft.powered_rail": "đường ray tăng tốc",
  "block.minecraft.detector_rail": "đường ray cảm biến",
  "block.minecraft.sticky_piston": "pít-tông dính",
  "block.minecraft.cobweb": "mạng nhện",
  "block.minecraft.grass": "cỏ",
  "block.minecraft.fern": "dương xỉ",
  "block.minecraft.dead_bush": "bụi cây khô",
  "block.minecraft.seagrass": "cỏ biển",
  "block.minecraft.sea_pickle": "dưa muối biển",
  "block.minecraft.piston": "pít-tông",
  "block.minecraft.white_wool": "len trắng",
  "block.minecraft.orange_wool": "len cam",
  "block.minecraft.magenta_wool": "len đỏ sậm",
  "block.minecraft.light_blue_wool": "len xanh nhạt",
  "block.minecraft.yellow_wool": "len vàng",
  "block.minecraft.lime_wool": "len xanh lá mạ",
  "block.minecraft.pink_wool": "len hồng",
  "block.minecraft.gray_wool": "len xám",
  "block.minecraft.light_gray_wool": "len xám nhạt",
  "block.minecraft.cyan_wool": "len lục lam",
  "block.minecraft.purple_wool": "len tím",
  "block.minecraft.blue_wool": "len xanh nước biển",
  "block.minecraft.brown_wool": "len nâu",
  "block.minecraft.green_wool": "len xanh lá cây",
  "block.minecraft.red_wool": "len đỏ",
  "block.minecraft.black_wool": "len đen",
  "block.minecraft.dandelion": "bồ công anh",
  "block.minecraft.poppy": "anh túc",
  "block.minecraft.blue_orchid": "phong lan xanh",
  "block.minecraft.allium": "hành tím",
  "block.minecraft.azure_bluet": "thiến thảo xanh",
  "block.minecraft.red_tulip": "uất kim hương đỏ",
  "block.minecraft.orange_tulip": "uất kim hương cam",
  "block.minecraft.white_tulip": "uất kim hương trắng",
  "block.minecraft.pink_tulip": "uất kim hương hồng",
  "block.minecraft.oxeye_daisy": "cúc trắng",
  "block.minecraft.cornflower": "thanh cúc",
  "block.minecraft.lily_of_the_valley": "linh lan",
  "block.minecraft.wither_rose": "hoa hồng wither",
  "block.minecraft.brown_mushroom": "nấm nâu",
  "block.minecraft.red_mushroom": "nấm đỏ",
  "block.minecraft.crimson_fungus": "nấm đỏ thẫm",
  "block.minecraft.warped_fungus": "nấm kì dị",
  "block.minecraft.crimson_roots": "rễ đỏ thẫm",
  "block.minecraft.warped_roots": "rễ kì dị",
  "block.minecraft.nether_sprouts": "mộng cây nether",
  "block.minecraft.weeping_vines": "dây leo đẫm máu",
  "block.minecraft.twisting_vines": "dây leo xoắn",
  "block.minecraft.sugar_cane": "cây mía",
  "block.minecraft.kelp": "tảo bẹ",
  "block.minecraft.bamboo": "cây tre",
  "block.minecraft.gold_block": "khối vàng",
  "block.minecraft.iron_block": "khối sắt",
  "block.minecraft.oak_slab": "phiến gỗ sồi",
  "block.minecraft.spruce_slab": "phiến gỗ vân sam",
  "block.minecraft.birch_slab": "phiến gỗ bạch dương",
  "block.minecraft.jungle_slab": "phiến gỗ rừng",
  "block.minecraft.acacia_slab": "phiến gỗ xiêm gai",
  "block.minecraft.dark_oak_slab": "phiến gỗ sồi sẫm",
  "block.minecraft.crimson_slab": "phiến đỏ thẫm",
  "block.minecraft.warped_slab": "phiến kì dị",
  "block.minecraft.stone_slab": "phiến đá",
  "block.minecraft.smooth_stone_slab": "phiến đá mịn",
  "block.minecraft.sandstone_slab": "phiến cát kết",
  "block.minecraft.cut_sandstone_slab": "phiến cát kết được cắt",
  "block.minecraft.petrified_oak_slab": "phiến gỗ sồi bị hóa đá",
  "block.minecraft.cobblestone_slab": "phiến đá cuội",
  "block.minecraft.brick_slab": "phiến gạch",
  "block.minecraft.stone_brick_slab": "phiến gạch đá",
  "block.minecraft.nether_brick_slab": "phiến gạch nether",
  "block.minecraft.quartz_slab": "phiến thạch anh",
  "block.minecraft.red_sandstone_slab": "phiến cát kết đỏ",
  "block.minecraft.cut_red_sandstone_slab": "phiến cát kết đỏ được cắt",
  "block.minecraft.purpur_slab": "phiến purpur",
  "block.minecraft.prismarine_slab": "phiến lăng trụ biển",
  "block.minecraft.prismarine_brick_slab": "phiến gạch lăng trụ biển",
  "block.minecraft.dark_prismarine_slab": "phiến lăng trụ biển sẫm màu",
  "block.minecraft.smooth_quartz": "khối thạch anh mịn",
  "block.minecraft.smooth_red_sandstone": "cát kết đỏ mịn",
  "block.minecraft.smooth_sandstone": "cát kết mịn",
  "block.minecraft.smooth_stone": "đá mịn",
  "block.minecraft.bricks": "gạch",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "kệ sách",
  "block.minecraft.mossy_cobblestone": "đá cuội phủ rêu",
  "block.minecraft.obsidian": "hắc diện thạch",
  "block.minecraft.torch": "đuốc",
  "block.minecraft.end_rod": "thanh gậy end",
  "block.minecraft.chorus_plant": "cây chorus",
  "block.minecraft.chorus_flower": "hoa chorus",
  "block.minecraft.purpur_block": "khối purpur",
  "block.minecraft.purpur_pillar": "cột trụ purpur",
  "block.minecraft.purpur_stairs": "cầu thang purpur",
  "block.minecraft.spawner": "lồng triệu hồi",
  "block.minecraft.oak_stairs": "cầu thang gỗ sồi",
  "block.minecraft.chest": "rương",
  "block.minecraft.diamond_ore": "quặng kim cương",
  "block.minecraft.diamond_block": "khối kim cương",
  "block.minecraft.crafting_table": "bàn chế tạo",
  "block.minecraft.farmland": "đất ruộng",
  "block.minecraft.furnace": "lò nung",
  "block.minecraft.ladder": "thang",
  "block.minecraft.rail": "đường ray",
  "block.minecraft.cobblestone_stairs": "cầu thang đá cuội",
  "block.minecraft.lever": "cần gạt",
  "block.minecraft.stone_pressure_plate": "đĩa cảm biến áp lực bằng đá",
  "block.minecraft.oak_pressure_plate": "đĩa cảm biến áp lực gỗ sồi",
  "block.minecraft.spruce_pressure_plate": "đĩa cảm biến áp lực gỗ vân sam",
  "block.minecraft.birch_pressure_plate": "đĩa cảm biến áp lực gỗ bạch dương",
  "block.minecraft.jungle_pressure_plate": "đĩa cảm biến áp lực gỗ rừng",
  "block.minecraft.acacia_pressure_plate": "đĩa cảm biến áp lực gỗ xiêm gai",
  "block.minecraft.dark_oak_pressure_plate": "đĩa cảm biến áp lực gỗ sồi sẫm",
  "block.minecraft.crimson_pressure_plate": "đĩa cảm biến áp lực đỏ thẫm",
  "block.minecraft.warped_pressure_plate": "đĩa cảm biến áp lực kì dị",
  "block.minecraft.polished_blackstone_pressure_plate": "đĩa cảm biến áp lực đá đen được đánh bóng",
  "block.minecraft.redstone_ore": "quặng redstone",
  "block.minecraft.redstone_torch": "đuốc redstone",
  "block.minecraft.snow": "tuyết",
  "block.minecraft.ice": "băng",
  "block.minecraft.snow_block": "khối tuyết",
  "block.minecraft.cactus": "cây xương rồng",
  "block.minecraft.clay": "đất sét",
  "block.minecraft.jukebox": "hộp chơi nhạc",
  "block.minecraft.oak_fence": "hàng rào gỗ sồi",
  "block.minecraft.spruce_fence": "hàng rào gỗ vân sam",
  "block.minecraft.birch_fence": "hàng rào gỗ bạch dương",
  "block.minecraft.jungle_fence": "hàng rào gỗ rừng",
  "block.minecraft.acacia_fence": "hàng rào gỗ xiêm gai",
  "block.minecraft.dark_oak_fence": "hàng rào gỗ sồi sẫm",
  "block.minecraft.crimson_fence": "hàng rào đỏ thẫm",
  "block.minecraft.warped_fence": "hàng rào kì dị",
  "block.minecraft.pumpkin": "bí ngô",
  "block.minecraft.carved_pumpkin": "bí ngô được khắc",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "cát linh hồn",
  "block.minecraft.soul_soil": "đất linh hồn",
  "block.minecraft.basalt": "đá bazan",
  "block.minecraft.polished_basalt": "đá bazan được đánh bóng",
  "block.minecraft.soul_torch": "đuốc linh hồn",
  "block.minecraft.glowstone": "đá phát sáng",
  "block.minecraft.jack_o_lantern": "đèn bí ngô",
  "block.minecraft.oak_trapdoor": "cửa sập gỗ sồi",
  "block.minecraft.spruce_trapdoor": "cửa sập gỗ vân sam",
  "block.minecraft.birch_trapdoor": "cửa sập gỗ bạch dương",
  "block.minecraft.jungle_trapdoor": "cửa sập gỗ rừng",
  "block.minecraft.acacia_trapdoor": "cửa sập gỗ xiêm gai",
  "block.minecraft.dark_oak_trapdoor": "cửa sập gỗ sồi sẫm",
  "block.minecraft.crimson_trapdoor": "cửa sập đỏ thẫm",
  "block.minecraft.warped_trapdoor": "cửa sập kì dị",
  "block.minecraft.infested_stone": "đá bị nhiễm khuẩn",
  "block.minecraft.infested_cobblestone": "đá cuội bị nhiễm khuẩn",
  "block.minecraft.infested_stone_bricks": "gạch đá bị nhiễm khuẩn",
  "block.minecraft.infested_mossy_stone_bricks": "gạch đá phủ rêu bị nhiễm khuẩn",
  "block.minecraft.infested_cracked_stone_bricks": "gạch đá nứt bị nhiễm khuẩn",
  "block.minecraft.infested_chiseled_stone_bricks": "gạch đá được đục bị nhiễm khuẩn",
  "block.minecraft.stone_bricks": "gạch đá",
  "block.minecraft.mossy_stone_bricks": "gạch đá phủ rêu",
  "block.minecraft.cracked_stone_bricks": "gạch đá nứt",
  "block.minecraft.chiseled_stone_bricks": "gạch đá được đục",
  "block.minecraft.brown_mushroom_block": "khối nấm nâu",
  "block.minecraft.red_mushroom_block": "khối nấm đỏ",
  "block.minecraft.mushroom_stem": "thân nấm",
  "block.minecraft.iron_bars": "hàng rào sắt",
  "block.minecraft.chain": "liền chuỗi",
  "block.minecraft.glass_pane": "tấm thủy tinh",
  "block.minecraft.melon": "dưa hấu",
  "block.minecraft.vine": "dây leo",
  "block.minecraft.oak_fence_gate": "cổng rào gỗ sồi",
  "block.minecraft.spruce_fence_gate": "cổng rào gỗ vân sam",
  "block.minecraft.birch_fence_gate": "cổng rào gỗ bạch dương",
  "block.minecraft.jungle_fence_gate": "cổng rào gỗ rừng",
  "block.minecraft.acacia_fence_gate": "cổng rào gỗ xiêm gai",
  "block.minecraft.dark_oak_fence_gate": "cổng rào gỗ sồi sẫm",
  "block.minecraft.crimson_fence_gate": "cổng rào đỏ thẫm",
  "block.minecraft.warped_fence_gate": "cổng rào kì dị",
  "block.minecraft.brick_stairs": "cầu thang gạch",
  "block.minecraft.stone_brick_stairs": "cầu thang gạch đá",
  "block.minecraft.mycelium": "khuẩn ty thể",
  "block.minecraft.lily_pad": "lá súng",
  "block.minecraft.nether_bricks": "gạch nether",
  "block.minecraft.cracked_nether_bricks": "gạch nether nứt",
  "block.minecraft.chiseled_nether_bricks": "gạch nether được đục",
  "block.minecraft.nether_brick_fence": "hàng rào gạch nether",
  "block.minecraft.nether_brick_stairs": "cầu thang gạch nether",
  "block.minecraft.enchanting_table": "bàn phù phép",
  "block.minecraft.end_portal_frame": "khung cổng end",
  "block.minecraft.end_stone": "đá end",
  "block.minecraft.end_stone_bricks": "gạch đá end",
  "block.minecraft.dragon_egg": "trứng rồng",
  "block.minecraft.redstone_lamp": "đèn redstone",
  "block.minecraft.sandstone_stairs": "cầu thang cát kết",
  "block.minecraft.emerald_ore": "quặng ngọc lục bảo",
  "block.minecraft.ender_chest": "rương ender",
  "block.minecraft.tripwire_hook": "móc dây bẫy",
  "block.minecraft.emerald_block": "khối ngọc lục bảo",
  "block.minecraft.spruce_stairs": "cầu thang gỗ vân sam",
  "block.minecraft.birch_stairs": "cầu thang gỗ bạch dương",
  "block.minecraft.jungle_stairs": "cầu thang gỗ rừng",
  "block.minecraft.crimson_stairs": "cầu thang đỏ thẫm",
  "block.minecraft.warped_stairs": "cầu thang kì dị",
  "block.minecraft.command_block": "khối điều khiển",
  "block.minecraft.beacon": "đèn hiệu",
  "block.minecraft.cobblestone_wall": "tường đá cuội",
  "block.minecraft.mossy_cobblestone_wall": "tường đá cuội phủ rêu",
  "block.minecraft.brick_wall": "tường gạch",
  "block.minecraft.prismarine_wall": "tường lăng trụ biển",
  "block.minecraft.red_sandstone_wall": "tường cát kết đỏ",
  "block.minecraft.mossy_stone_brick_wall": "tường gạch đá phủ rêu",
  "block.minecraft.granite_wall": "tường đá hoa cương",
  "block.minecraft.stone_brick_wall": "tường gạch đá",
  "block.minecraft.nether_brick_wall": "tường gạch nether",
  "block.minecraft.andesite_wall": "tường đá andesit",
  "block.minecraft.red_nether_brick_wall": "tường gạch nether đỏ",
  "block.minecraft.sandstone_wall": "tường cát kết",
  "block.minecraft.end_stone_brick_wall": "tường gạch đá end",
  "block.minecraft.diorite_wall": "tường đá diorit",
  "block.minecraft.blackstone_wall": "tường đá đen",
  "block.minecraft.polished_blackstone_wall": "tường đá đen được đánh bóng",
  "block.minecraft.polished_blackstone_brick_wall": "tường gạch đá đen được đánh bóng",
  "block.minecraft.stone_button": "nút đá",
  "block.minecraft.oak_button": "nút gỗ sồi",
  "block.minecraft.spruce_button": "nút gỗ vân sam",
  "block.minecraft.birch_button": "nút gỗ bạch dương",
  "block.minecraft.jungle_button": "nút gỗ rừng",
  "block.minecraft.acacia_button": "nút gỗ xiêm gai",
  "block.minecraft.dark_oak_button": "nút gỗ sồi sẫm",
  "block.minecraft.crimson_button": "nút đỏ thẫm",
  "block.minecraft.warped_button": "nút kì dị",
  "block.minecraft.polished_blackstone_button": "nút đá đen được đánh bóng",
  "block.minecraft.anvil": "cái đe",
  "block.minecraft.chipped_anvil": "cái đe bị nứt",
  "block.minecraft.damaged_anvil": "cái đe bị hỏng",
  "block.minecraft.trapped_chest": "rương bị kẹt",
  "block.minecraft.light_weighted_pressure_plate": "đĩa cảm biến áp lực nhẹ",
  "block.minecraft.heavy_weighted_pressure_plate": "đĩa cảm biến áp lực nặng",
  "block.minecraft.daylight_detector": "máy dò ánh sáng",
  "block.minecraft.redstone_block": "khối redstone",
  "block.minecraft.nether_quartz_ore": "quặng thạch anh nether",
  "block.minecraft.hopper": "cái phễu",
  "block.minecraft.chiseled_quartz_block": "khối thạch anh được đục",
  "block.minecraft.quartz_block": "khối thạch anh",
  "block.minecraft.quartz_bricks": "gạch thạch anh",
  "block.minecraft.quartz_pillar": "cột trụ thạch anh",
  "block.minecraft.quartz_stairs": "cầu thang thạch anh",
  "block.minecraft.activator_rail": "đường ray kích hoạt",
  "block.minecraft.dropper": "máy thả",
  "block.minecraft.white_terracotta": "đất nung trắng",
  "block.minecraft.orange_terracotta": "đất nung cam",
  "block.minecraft.magenta_terracotta": "đất nung đỏ sậm",
  "block.minecraft.light_blue_terracotta": "đất nung xanh nước biển nhạt",
  "block.minecraft.yellow_terracotta": "đất nung vàng",
  "block.minecraft.lime_terracotta": "đất nung xanh lá mạ",
  "block.minecraft.pink_terracotta": "đất nung hồng",
  "block.minecraft.gray_terracotta": "đất nung xám",
  "block.minecraft.light_gray_terracotta": "đất nung xám nhạt",
  "block.minecraft.cyan_terracotta": "đất nung lục lam",
  "block.minecraft.purple_terracotta": "đất nung tím",
  "block.minecraft.blue_terracotta": "đất nung xanh nước biển",
  "block.minecraft.brown_terracotta": "đất nung nâu",
  "block.minecraft.green_terracotta": "đất nung xanh lá cây",
  "block.minecraft.red_terracotta": "đất nung đỏ",
  "block.minecraft.black_terracotta": "đất nung đen",
  "block.minecraft.barrier": "rào chắn",
  "block.minecraft.iron_trapdoor": "cửa sập sắt",
  "block.minecraft.hay_block": "kiện rơm",
  "block.minecraft.white_carpet": "thảm trắng",
  "block.minecraft.orange_carpet": "thảm cam",
  "block.minecraft.magenta_carpet": "thảm đỏ sậm",
  "block.minecraft.light_blue_carpet": "thảm xanh nước biển nhạt",
  "block.minecraft.yellow_carpet": "thảm vàng",
  "block.minecraft.lime_carpet": "thảm xanh lá mạ",
  "block.minecraft.pink_carpet": "thảm hồng",
  "block.minecraft.gray_carpet": "thảm xám",
  "block.minecraft.light_gray_carpet": "thảm xám nhạt",
  "block.minecraft.cyan_carpet": "thảm lục lam",
  "block.minecraft.purple_carpet": "thảm tím",
  "block.minecraft.blue_carpet": "thảm xanh nước biển",
  "block.minecraft.brown_carpet": "thảm nâu",
  "block.minecraft.green_carpet": "thảm xanh lá cây",
  "block.minecraft.red_carpet": "thảm đỏ",
  "block.minecraft.black_carpet": "thảm đen",
  "block.minecraft.terracotta": "đất nung",
  "block.minecraft.coal_block": "khối than",
  "block.minecraft.packed_ice": "băng nén",
  "block.minecraft.acacia_stairs": "cầu thang gỗ xiêm gai",
  "block.minecraft.dark_oak_stairs": "cầu thang gỗ sồi sẫm",
  "block.minecraft.slime_block": "khối chất nhờn",
  "block.minecraft.grass_path": "đường đi trên cỏ",
  "block.minecraft.sunflower": "hướng dương",
  "block.minecraft.lilac": "tử đinh hương",
  "block.minecraft.rose_bush": "bụi hoa hồng",
  "block.minecraft.peony": "mẫu đơn",
  "block.minecraft.tall_grass": "cỏ cao",
  "block.minecraft.large_fern": "dương xỉ lớn",
  "block.minecraft.white_stained_glass": "thủy tinh được nhuộm trắng",
  "block.minecraft.orange_stained_glass": "thủy tinh được nhuộm cam",
  "block.minecraft.magenta_stained_glass": "thủy tinh được nhuộm đỏ sậm",
  "block.minecraft.light_blue_stained_glass": "thủy tinh được nhuộm xanh nước biển nhạt",
  "block.minecraft.yellow_stained_glass": "thủy tinh được nhuộm vàng",
  "block.minecraft.lime_stained_glass": "thủy tinh được nhuộm xanh lá mạ",
  "block.minecraft.pink_stained_glass": "thủy tinh được nhuộm hồng",
  "block.minecraft.gray_stained_glass": "thủy tinh được nhuộm xám",
  "block.minecraft.light_gray_stained_glass": "thủy tinh được nhuộm xám nhạt",
  "block.minecraft.cyan_stained_glass": "thủy tinh được nhuộm lục lam",
  "block.minecraft.purple_stained_glass": "thủy tinh được nhuộm tím",
  "block.minecraft.blue_stained_glass": "thủy tinh được nhuộm xanh nước biển",
  "block.minecraft.brown_stained_glass": "thủy tinh được nhuộm nâu",
  "block.minecraft.green_stained_glass": "thủy tinh được nhuộm xanh lá cây",
  "block.minecraft.red_stained_glass": "thủy tinh được nhuộm đỏ",
  "block.minecraft.black_stained_glass": "thủy tinh được nhuộm đen",
  "block.minecraft.white_stained_glass_pane": "tấm thủy tinh được nhuộm trắng",
  "block.minecraft.orange_stained_glass_pane": "tấm thủy tinh được nhuộm cam",
  "block.minecraft.magenta_stained_glass_pane": "tấm thủy tinh được nhuộm đỏ sậm",
  "block.minecraft.light_blue_stained_glass_pane": "tấm thủy tinh được nhuộm xanh nước biển nhạt",
  "block.minecraft.yellow_stained_glass_pane": "tấm thủy tinh được nhuộm vàng",
  "block.minecraft.lime_stained_glass_pane": "tấm thủy tinh được nhuộm xanh lá mạ",
  "block.minecraft.pink_stained_glass_pane": "tấm thủy tinh được nhuộm hồng",
  "block.minecraft.gray_stained_glass_pane": "tấm thủy tinh được nhuộm xám",
  "block.minecraft.light_gray_stained_glass_pane": "tấm thủy tinh được nhuộm xám nhạt",
  "block.minecraft.cyan_stained_glass_pane": "tấm thủy tinh được nhuộm lục lam",
  "block.minecraft.purple_stained_glass_pane": "tấm thủy tinh được nhuộm tím",
  "block.minecraft.blue_stained_glass_pane": "tấm thủy tinh được nhuộm xanh nước biển",
  "block.minecraft.brown_stained_glass_pane": "tấm thủy tinh được nhuộm nâu",
  "block.minecraft.green_stained_glass_pane": "tấm thủy tinh được nhuộm xanh lá cây",
  "block.minecraft.red_stained_glass_pane": "tấm thủy tinh được nhuộm đỏ",
  "block.minecraft.black_stained_glass_pane": "tấm thủy tinh được nhuộm đen",
  "block.minecraft.prismarine": "lăng trụ biển",
  "block.minecraft.prismarine_bricks": "gạch lăng trụ biển",
  "block.minecraft.dark_prismarine": "lăng trụ biển sẫm màu",
  "block.minecraft.prismarine_stairs": "cầu thang lăng trụ biển",
  "block.minecraft.prismarine_brick_stairs": "cầu thang gạch lăng trụ biển",
  "block.minecraft.dark_prismarine_stairs": "cầu thang lăng trụ biển sẫm màu",
  "block.minecraft.sea_lantern": "đèn biển",
  "block.minecraft.red_sandstone": "cát kết đỏ",
  "block.minecraft.chiseled_red_sandstone": "cát kết đỏ được đục",
  "block.minecraft.cut_red_sandstone": "cát kết đỏ được cắt",
  "block.minecraft.red_sandstone_stairs": "cầu thang cát kết đỏ",
  "block.minecraft.repeating_command_block": "khối điều khiển lặp lại",
  "block.minecraft.chain_command_block": "khối điều khiển liền chuỗi",
  "block.minecraft.magma_block": "khối dung nham",
  "block.minecraft.nether_wart_block": "khối bướu nether",
  "block.minecraft.warped_wart_block": "khối bướu kì dị",
  "block.minecraft.red_nether_bricks": "gạch nether đỏ",
  "block.minecraft.bone_block": "khối xương",
  "block.minecraft.structure_void": "cấu trúc trống",
  "block.minecraft.observer": "khối theo dõi",
  "block.minecraft.shulker_box": "hộp shulker",
  "block.minecraft.white_shulker_box": "hộp shulker trắng",
  "block.minecraft.orange_shulker_box": "hộp shulker cam",
  "block.minecraft.magenta_shulker_box": "hộp shulker đỏ sậm",
  "block.minecraft.light_blue_shulker_box": "hộp shulker xanh nước biển nhạt",
  "block.minecraft.yellow_shulker_box": "hộp shulker vàng",
  "block.minecraft.lime_shulker_box": "hộp shulker xanh lá mạ",
  "block.minecraft.pink_shulker_box": "hộp shulker hồng",
  "block.minecraft.gray_shulker_box": "hộp shulker xám",
  "block.minecraft.light_gray_shulker_box": "hộp shulker xám nhạt",
  "block.minecraft.cyan_shulker_box": "hộp shulker lục lam",
  "block.minecraft.purple_shulker_box": "hộp shulker tím",
  "block.minecraft.blue_shulker_box": "hộp shulker xanh nước biển",
  "block.minecraft.brown_shulker_box": "hộp shulker nâu",
  "block.minecraft.green_shulker_box": "hộp shulker xanh lá cây",
  "block.minecraft.red_shulker_box": "hộp shulker đỏ",
  "block.minecraft.black_shulker_box": "hộp shulker đen",
  "block.minecraft.white_glazed_terracotta": "đất nung tráng men trắng",
  "block.minecraft.orange_glazed_terracotta": "đất nung tráng men cam",
  "block.minecraft.magenta_glazed_terracotta": "đất nung tráng men đỏ sậm",
  "block.minecraft.light_blue_glazed_terracotta": "đất nung tráng men xanh nước biển nhạt",
  "block.minecraft.yellow_glazed_terracotta": "đất nung tráng men vàng",
  "block.minecraft.lime_glazed_terracotta": "đất nung tráng men xanh lá mạ",
  "block.minecraft.pink_glazed_terracotta": "đất nung tráng men hồng",
  "block.minecraft.gray_glazed_terracotta": "đất nung tráng men xám",
  "block.minecraft.light_gray_glazed_terracotta": "đất nung tráng men xám nhạt",
  "block.minecraft.cyan_glazed_terracotta": "đất nung tráng men lục lam",
  "block.minecraft.purple_glazed_terracotta": "đất nung tráng men tím",
  "block.minecraft.blue_glazed_terracotta": "đất nung tráng men xanh nước biển",
  "block.minecraft.brown_glazed_terracotta": "đất nung tráng men nâu",
  "block.minecraft.green_glazed_terracotta": "đất nung tráng men xanh lá cây",
  "block.minecraft.red_glazed_terracotta": "đất nung tráng men đỏ",
  "block.minecraft.black_glazed_terracotta": "đất nung tráng men đen",
  "block.minecraft.white_concrete": "bê tông trắng",
  "block.minecraft.orange_concrete": "bê tông cam",
  "block.minecraft.magenta_concrete": "bê tông đỏ sậm",
  "block.minecraft.light_blue_concrete": "bê tông xanh nước biển nhạt",
  "block.minecraft.yellow_concrete": "bê tông vàng",
  "block.minecraft.lime_concrete": "bê tông xanh lá mạ",
  "block.minecraft.pink_concrete": "bê tông hồng",
  "block.minecraft.gray_concrete": "bê tông xám",
  "block.minecraft.light_gray_concrete": "bê tông xám nhạt",
  "block.minecraft.cyan_concrete": "bê tông lục lam",
  "block.minecraft.purple_concrete": "bê tông tím",
  "block.minecraft.blue_concrete": "bê tông xanh nước biển",
  "block.minecraft.brown_concrete": "bê tông nâu",
  "block.minecraft.green_concrete": "bê tông xanh lá cây",
  "block.minecraft.red_concrete": "bê tông đỏ",
  "block.minecraft.black_concrete": "bê tông đen",
  "block.minecraft.white_concrete_powder": "bột bê tông trắng",
  "block.minecraft.orange_concrete_powder": "bột bê tông cam",
  "block.minecraft.magenta_concrete_powder": "bột bê tông đỏ sậm",
  "block.minecraft.light_blue_concrete_powder": "bột bê tông xanh nước biển nhạt",
  "block.minecraft.yellow_concrete_powder": "bột bê tông vàng",
  "block.minecraft.lime_concrete_powder": "bột bê tông xanh lá mạ",
  "block.minecraft.pink_concrete_powder": "bột bê tông hồng",
  "block.minecraft.gray_concrete_powder": "bột bê tông xám",
  "block.minecraft.light_gray_concrete_powder": "bột bê tông xám nhạt",
  "block.minecraft.cyan_concrete_powder": "bột bê tông lục lam",
  "block.minecraft.purple_concrete_powder": "bột bê tông tím",
  "block.minecraft.blue_concrete_powder": "bột bê tông xanh nước biển",
  "block.minecraft.brown_concrete_powder": "bột bê tông nâu",
  "block.minecraft.green_concrete_powder": "bột bê tông xanh lá cây",
  "block.minecraft.red_concrete_powder": "bột bê tông đỏ",
  "block.minecraft.black_concrete_powder": "bột bê tông đen",
  "block.minecraft.turtle_egg": "trứng rùa",
  "block.minecraft.dead_tube_coral_block": "khối san hô ống tròn chết",
  "block.minecraft.dead_brain_coral_block": "khối san hô não chết",
  "block.minecraft.dead_bubble_coral_block": "khối san hô bong bóng chết",
  "block.minecraft.dead_fire_coral_block": "khối san hô lửa chết",
  "block.minecraft.dead_horn_coral_block": "khối san hô sừng chết",
  "block.minecraft.tube_coral_block": "khối san hô ống tròn",
  "block.minecraft.brain_coral_block": "khối san hô não",
  "block.minecraft.bubble_coral_block": "khối san hô bong bóng",
  "block.minecraft.fire_coral_block": "khối san hô lửa",
  "block.minecraft.horn_coral_block": "khối san hô sừng",
  "block.minecraft.tube_coral": "san hô ống tròn",
  "block.minecraft.brain_coral": "san hô não",
  "block.minecraft.bubble_coral": "san hô bong bóng",
  "block.minecraft.fire_coral": "san hô lửa",
  "block.minecraft.horn_coral": "san hô sừng",
  "block.minecraft.dead_brain_coral": "san hô não chết",
  "block.minecraft.dead_bubble_coral": "san hô bong bóng chết",
  "block.minecraft.dead_fire_coral": "san hô lửa chết",
  "block.minecraft.dead_horn_coral": "san hô sừng chết",
  "block.minecraft.dead_tube_coral": "san hô ống tròn chết",
  "block.minecraft.tube_coral_fan": "san hô ống tròn hình quạt",
  "block.minecraft.brain_coral_fan": "san hô não hình quạt",
  "block.minecraft.bubble_coral_fan": "san hô bong bóng hình quạt",
  "block.minecraft.fire_coral_fan": "san hô lửa hình quạt",
  "block.minecraft.horn_coral_fan": "san hô sừng hình quạt",
  "block.minecraft.dead_tube_coral_fan": "san hô ống tròn hình quạt chết",
  "block.minecraft.dead_brain_coral_fan": "san hô não hình quạt chết",
  "block.minecraft.dead_bubble_coral_fan": "san hô bong bóng hình quạt chết",
  "block.minecraft.dead_fire_coral_fan": "san hô lửa hình quạt chết",
  "block.minecraft.dead_horn_coral_fan": "san hô sừng hình quạt chết",
  "block.minecraft.blue_ice": "băng xanh",
  "block.minecraft.conduit": "ống dẫn",
  "block.minecraft.polished_granite_stairs": "cầu thang đá hoa cương được đánh bóng",
  "block.minecraft.smooth_red_sandstone_stairs": "cầu thang cát kết đỏ mịn",
  "block.minecraft.mossy_stone_brick_stairs": "cầu thang gạch đá phủ rêu",
  "block.minecraft.polished_diorite_stairs": "cầu thang đá diorit được đánh bóng",
  "block.minecraft.mossy_cobblestone_stairs": "cầu thang đá cuội phủ rêu",
  "block.minecraft.end_stone_brick_stairs": "cầu thang gạch đá end",
  "block.minecraft.stone_stairs": "cầu thang đá",
  "block.minecraft.smooth_sandstone_stairs": "cầu thang cát kết mịn",
  "block.minecraft.smooth_quartz_stairs": "cầu thang thạch anh mịn",
  "block.minecraft.granite_stairs": "cầu thang đá hoa cương",
  "block.minecraft.andesite_stairs": "cầu thang đá andesit",
  "block.minecraft.red_nether_brick_stairs": "cầu thang gạch nether đỏ",
  "block.minecraft.polished_andesite_stairs": "cầu thang đá andesit được đánh bóng",
  "block.minecraft.diorite_stairs": "cầu thang đá diorit",
  "block.minecraft.polished_granite_slab": "phiến đá hoa cương được đánh bóng",
  "block.minecraft.smooth_red_sandstone_slab": "phiến cát kết đỏ mịn",
  "block.minecraft.mossy_stone_brick_slab": "phiến gạch đá phủ rêu",
  "block.minecraft.polished_diorite_slab": "phiến đá diorit được đánh bóng",
  "block.minecraft.mossy_cobblestone_slab": "phiến đá cuội phủ rêu",
  "block.minecraft.end_stone_brick_slab": "phiến gạch đá end",
  "block.minecraft.smooth_sandstone_slab": "phiến cát kết mịn",
  "block.minecraft.smooth_quartz_slab": "phiến thạch anh mịn",
  "block.minecraft.granite_slab": "phiến đá hoa cương",
  "block.minecraft.andesite_slab": "phiến đá andesit",
  "block.minecraft.red_nether_brick_slab": "phiến gạch nether đỏ",
  "block.minecraft.polished_andesite_slab": "phiến đá andesit được đánh bóng",
  "block.minecraft.diorite_slab": "phiến đá diorit",
  "block.minecraft.scaffolding": "giàn giáo",
  "block.minecraft.iron_door": "cửa sắt",
  "block.minecraft.oak_door": "cửa gỗ sồi",
  "block.minecraft.spruce_door": "cửa gỗ vân sam",
  "block.minecraft.birch_door": "cửa gỗ bạch dương",
  "block.minecraft.jungle_door": "cửa gỗ rừng",
  "block.minecraft.acacia_door": "cửa gỗ xiêm gai",
  "block.minecraft.dark_oak_door": "cửa gỗ sồi sẫm",
  "block.minecraft.crimson_door": "cửa đỏ thẫm",
  "block.minecraft.warped_door": "cửa kì dị",
  "block.minecraft.repeater": "bộ lặp redstone",
  "block.minecraft.comparator": "mạch so sánh redstone",
  "block.minecraft.structure_block": "khối cấu trúc",
  "block.minecraft.jigsaw": "khối mảnh ghép",
  "item.minecraft.turtle_helmet": "mai rùa□□khi ở đầu:□+2 giáp",
  "item.minecraft.scute": "vảy",
  "item.minecraft.iron_shovel": "xẻng sắt□□khi ở trong tay chính:□+3.5 sức tấn công□-3 tốc độ tấn công",
  "item.minecraft.iron_pickaxe": "cuốc chim sắt□□khi ở trong tay chính:□+3 sức tấn công□-2.8 tốc độ tấn công",
  "item.minecraft.iron_axe": "rìu sắt□□khi ở trong tay chính:□+8 sức tấn công□-3.1 tốc độ tấn công",
  "item.minecraft.flint_and_steel": "dụng cụ đánh lửa",
  "item.minecraft.apple": "táo",
  "item.minecraft.bow": "cung",
  "item.minecraft.arrow": "mũi tên",
  "item.minecraft.coal": "than",
  "item.minecraft.charcoal": "than gỗ",
  "item.minecraft.diamond": "kim cương",
  "item.minecraft.iron_ingot": "phôi sắt",
  "item.minecraft.gold_ingot": "phôi vàng",
  "item.minecraft.netherite_ingot": "phôi netherit",
  "item.minecraft.netherite_scrap": "vụn netherit",
  "item.minecraft.iron_sword": "kiếm sắt□□khi ở trong tay chính:□+5 sức tấn công□-2.4 tốc độ tấn công",
  "item.minecraft.wooden_sword": "kiếm gỗ□□khi ở trong tay chính:□+3 sức tấn công□-2.4 tốc độ tấn công",
  "item.minecraft.wooden_shovel": "xẻng gỗ□□khi ở trong tay chính:□+1.5 sức tấn công□-3 tốc độ tấn công",
  "item.minecraft.wooden_pickaxe": "cuốc chim gỗ□□khi ở trong tay chính:□+1 sức tấn công□-2.8 tốc độ tấn công",
  "item.minecraft.wooden_axe": "rìu gỗ□□khi ở trong tay chính:□+6 sức tấn công□-3.2 tốc độ tấn công",
  "item.minecraft.stone_sword": "kiếm đá□□khi ở trong tay chính:□+4 sức tấn công□-2.4 tốc độ tấn công",
  "item.minecraft.stone_shovel": "xẻng đá□□khi ở trong tay chính:□+2.5 sức tấn công□-3 tốc độ tấn công",
  "item.minecraft.stone_pickaxe": "cuốc chim đá□□khi ở trong tay chính:□+2 sức tấn công□-2.8 tốc độ tấn công",
  "item.minecraft.stone_axe": "rìu đá□□khi ở trong tay chính:□+8 sức tấn công□-3.2 tốc độ tấn công",
  "item.minecraft.diamond_sword": "kiếm kim cương□□khi ở trong tay chính:□+6 sức tấn công□-2.4 tốc độ tấn công",
  "item.minecraft.diamond_shovel": "xẻng kim cương□□khi ở trong tay chính:□+4.5 sức tấn công□-3 tốc độ tấn công",
  "item.minecraft.diamond_pickaxe": "cuốc chim kim cương□□khi ở trong tay chính:□+4 sức tấn công□-2.8 tốc độ tấn công",
  "item.minecraft.diamond_axe": "rìu kim cương□□khi ở trong tay chính:□+8 sức tấn công□-3 tốc độ tấn công",
  "item.minecraft.stick": "gậy",
  "item.minecraft.bowl": "cái bát",
  "item.minecraft.mushroom_stew": "súp nấm",
  "item.minecraft.golden_sword": "kiếm vàng□□khi ở trong tay chính:□+3 sức tấn công□-2.4 tốc độ tấn công",
  "item.minecraft.golden_shovel": "xẻng vàng□□khi ở trong tay chính:□+1.5 sức tấn công□-3 tốc độ tấn công",
  "item.minecraft.golden_pickaxe": "cuốc chim vàng□□khi ở trong tay chính:□+1 sức tấn công□-2.8 tốc độ tấn công",
  "item.minecraft.golden_axe": "rìu vàng□□khi ở trong tay chính:□+6 sức tấn công□-3 tốc độ tấn công",
  "item.minecraft.netherite_sword": "kiếm netherit□□khi ở trong tay chính:□+7 sức tấn công□-2.4 tốc độ tấn công",
  "item.minecraft.netherite_shovel": "xẻng netherit□□khi ở trong tay chính:□+5.5 sức tấn công□-3 tốc độ tấn công",
  "item.minecraft.netherite_pickaxe": "cuốc chim netherit□□khi ở trong tay chính:□+5 sức tấn công□-2.8 tốc độ tấn công",
  "item.minecraft.netherite_axe": "rìu netherit□□khi ở trong tay chính:□+9 sức tấn công□-3 tốc độ tấn công",
  "item.minecraft.string": "sợi chỉ",
  "item.minecraft.feather": "lông",
  "item.minecraft.gunpowder": "thuốc súng",
  "item.minecraft.wooden_hoe": "cuốc gỗ□□khi ở trong tay chính:□-3 tốc độ tấn công",
  "item.minecraft.stone_hoe": "cuốc đá□□khi ở trong tay chính:□-2 tốc độ tấn công",
  "item.minecraft.iron_hoe": "cuốc sắt□□khi ở trong tay chính:□-1 tốc độ tấn công",
  "item.minecraft.diamond_hoe": "cuốc kim cương□□khi ở trong tay chính:",
  "item.minecraft.golden_hoe": "cuốc vàng□□khi ở trong tay chính:□-3 tốc độ tấn công",
  "item.minecraft.netherite_hoe": "cuốc netherit□□khi ở trong tay chính:",
  "item.minecraft.wheat_seeds": "hạt lúa mì",
  "item.minecraft.wheat": "lúa mì",
  "item.minecraft.bread": "bánh mì",
  "item.minecraft.leather_helmet": "mũ da□□khi ở đầu:□+1 giáp",
  "item.minecraft.leather_chestplate": "áo da□□khi ở trên người:□+3 giáp",
  "item.minecraft.leather_leggings": "quần da□□khi ở chân:□+2 giáp",
  "item.minecraft.leather_boots": "ủng da□□khi ở bàn chân:□+1 giáp",
  "item.minecraft.chainmail_helmet": "mũ xích□□khi ở đầu:□+2 giáp",
  "item.minecraft.chainmail_chestplate": "áo xích□□khi ở trên người:□+5 giáp",
  "item.minecraft.chainmail_leggings": "quần xích□□khi ở chân:□+4 giáp",
  "item.minecraft.chainmail_boots": "ủng xích□□khi ở bàn chân:□+1 giáp",
  "item.minecraft.iron_helmet": "mũ sắt□□khi ở đầu:□+2 giáp",
  "item.minecraft.iron_chestplate": "áo sắt□□khi ở trên người:□+6 giáp",
  "item.minecraft.iron_leggings": "quần sắt□□khi ở chân:□+5 giáp",
  "item.minecraft.iron_boots": "ủng sắt□□khi ở bàn chân:□+2 giáp",
  "item.minecraft.diamond_helmet": "mũ kim cương□□khi ở đầu:□+3 giáp□+2 độ bền áo giáp",
  "item.minecraft.diamond_chestplate": "áo kim cương□□khi ở trên người:□+8 giáp□+2 độ bền áo giáp",
  "item.minecraft.diamond_leggings": "quần kim cương□□khi ở chân:□+6 giáp□+2 độ bền áo giáp",
  "item.minecraft.diamond_boots": "ủng kim cương□□khi ở bàn chân:□+3 giáp□+2 độ bền áo giáp",
  "item.minecraft.golden_helmet": "mũ vàng□□khi ở đầu:□+2 giáp",
  "item.minecraft.golden_chestplate": "áo vàng□□khi ở trên người:□+5 giáp",
  "item.minecraft.golden_leggings": "quần vàng□□khi ở chân:□+3 giáp",
  "item.minecraft.golden_boots": "ủng vàng□□khi ở bàn chân:□+1 giáp",
  "item.minecraft.netherite_helmet": "mũ netherit□□khi ở đầu:□+3 giáp□+3 độ bền áo giáp□+1 kháng đẩy lùi",
  "item.minecraft.netherite_chestplate": "áo netherit□□khi ở trên người:□+8 giáp□+3 độ bền áo giáp□+1 kháng đẩy lùi",
  "item.minecraft.netherite_leggings": "quần netherit□□khi ở chân:□+6 giáp□+3 độ bền áo giáp□+1 kháng đẩy lùi",
  "item.minecraft.netherite_boots": "ủng netherit□□khi ở bàn chân:□+3 giáp□+3 độ bền áo giáp□+1 kháng đẩy lùi",
  "item.minecraft.flint": "đá lửa",
  "item.minecraft.porkchop": "thịt heo sống",
  "item.minecraft.cooked_porkchop": "thịt heo chín",
  "item.minecraft.painting": "tranh vẽ",
  "item.minecraft.golden_apple": "táo vàng",
  "item.minecraft.enchanted_golden_apple": "táo vàng được phù phép",
  "block.minecraft.oak_sign": "tấm biển gỗ sồi",
  "block.minecraft.spruce_sign": "tấm biển gỗ vân sam",
  "block.minecraft.birch_sign": "tấm biển gỗ bạch dương",
  "block.minecraft.jungle_sign": "tấm biển gỗ rừng",
  "block.minecraft.acacia_sign": "tấm biển gỗ xiêm gai",
  "block.minecraft.dark_oak_sign": "tấm biển gỗ sồi sẫm",
  "block.minecraft.crimson_sign": "tấm biển đỏ thẫm",
  "block.minecraft.warped_sign": "tấm biển kì dị",
  "item.minecraft.bucket": "xô",
  "item.minecraft.water_bucket": "xô nước",
  "item.minecraft.lava_bucket": "xô dung nham",
  "item.minecraft.minecart": "xe mỏ",
  "item.minecraft.saddle": "yên cưỡi",
  "item.minecraft.redstone": "bột redstone",
  "item.minecraft.snowball": "bóng tuyết",
  "item.minecraft.oak_boat": "thuyền gỗ sồi",
  "item.minecraft.leather": "da thuộc",
  "item.minecraft.milk_bucket": "xô sữa",
  "item.minecraft.pufferfish_bucket": "xô cá nóc",
  "item.minecraft.salmon_bucket": "xô cá hồi",
  "item.minecraft.cod_bucket": "xô cá tuyết",
  "item.minecraft.tropical_fish_bucket": "xô cá nhiệt đới",
  "item.minecraft.brick": "viên gạch",
  "item.minecraft.clay_ball": "quả cầu đất sét",
  "block.minecraft.dried_kelp_block": "khối tảo bẹ khô",
  "item.minecraft.paper": "giấy",
  "item.minecraft.book": "quyển sách",
  "item.minecraft.slime_ball": "bóng nhờn",
  "item.minecraft.chest_minecart": "xe mỏ có rương",
  "item.minecraft.furnace_minecart": "xe mỏ có lò nung",
  "item.minecraft.egg": "trứng",
  "item.minecraft.compass": "la bàn",
  "item.minecraft.fishing_rod": "cần câu cá",
  "item.minecraft.clock": "đồng hồ",
  "item.minecraft.glowstone_dust": "bột đá phát sáng",
  "item.minecraft.cod": "cá tuyết sống",
  "item.minecraft.salmon": "cá hồi sống",
  "item.minecraft.tropical_fish": "cá nhiệt đới",
  "item.minecraft.pufferfish": "cá nóc",
  "item.minecraft.cooked_cod": "cá tuyết chín",
  "item.minecraft.cooked_salmon": "cá hồi chín",
  "item.minecraft.ink_sac": "túi mực",
  "item.minecraft.red_dye": "bột nhuộm đỏ",
  "item.minecraft.green_dye": "bột nhuộm xanh lá cây",
  "item.minecraft.cocoa_beans": "hạt ca cao",
  "item.minecraft.lapis_lazuli": "ngọc lưu ly",
  "item.minecraft.purple_dye": "bột nhuộm tím",
  "item.minecraft.cyan_dye": "bột nhuộm lục lam",
  "item.minecraft.light_gray_dye": "bột nhuộm xám nhạt",
  "item.minecraft.gray_dye": "bột nhuộm xám",
  "item.minecraft.pink_dye": "bột nhuộm hồng",
  "item.minecraft.lime_dye": "bột nhuộm xanh lá mạ",
  "item.minecraft.yellow_dye": "bột nhuộm vàng",
  "item.minecraft.light_blue_dye": "bột nhuộm xanh nhạt",
  "item.minecraft.magenta_dye": "bột nhuộm đỏ sậm",
  "item.minecraft.orange_dye": "bột nhuộm cam",
  "item.minecraft.bone_meal": "bột xương",
  "item.minecraft.blue_dye": "bột nhuộm xanh nước biển",
  "item.minecraft.brown_dye": "bột nhuộm nâu",
  "item.minecraft.black_dye": "bột nhuộm đen",
  "item.minecraft.white_dye": "bột nhuộm trắng",
  "item.minecraft.bone": "xương",
  "item.minecraft.sugar": "đường",
  "block.minecraft.cake": "bánh ngọt",
  "block.minecraft.white_bed": "giường trắng",
  "block.minecraft.orange_bed": "giường cam",
  "block.minecraft.magenta_bed": "giường đỏ sậm",
  "block.minecraft.light_blue_bed": "giường xanh nước biển nhạt",
  "block.minecraft.yellow_bed": "giường vàng",
  "block.minecraft.lime_bed": "giường xanh lá mạ",
  "block.minecraft.pink_bed": "giường hồng",
  "block.minecraft.gray_bed": "giường xám",
  "block.minecraft.light_gray_bed": "giường xám nhạt",
  "block.minecraft.cyan_bed": "giường lục lam",
  "block.minecraft.purple_bed": "giường tím",
  "block.minecraft.blue_bed": "giường xanh nước biển",
  "block.minecraft.brown_bed": "giường nâu",
  "block.minecraft.green_bed": "giường xanh lá cây",
  "block.minecraft.red_bed": "giường đỏ",
  "block.minecraft.black_bed": "giường đen",
  "item.minecraft.cookie": "bánh quy",
  "item.minecraft.filled_map": "bản đồ□#0",
  "item.minecraft.shears": "kéo tỉa",
  "item.minecraft.melon_slice": "lát cắt dưa hấu",
  "item.minecraft.dried_kelp": "tảo bẹ khô",
  "item.minecraft.pumpkin_seeds": "hạt bí ngô",
  "item.minecraft.melon_seeds": "hạt dưa hấu",
  "item.minecraft.beef": "thịt bò sống",
  "item.minecraft.cooked_beef": "bít tết",
  "item.minecraft.chicken": "thịt gà sống",
  "item.minecraft.cooked_chicken": "thịt gà chín",
  "item.minecraft.rotten_flesh": "thịt thối rữa",
  "item.minecraft.ender_pearl": "ngọc ender",
  "item.minecraft.blaze_rod": "que của quỷ lửa",
  "item.minecraft.ghast_tear": "nước mắt ghast",
  "item.minecraft.gold_nugget": "hạt vàng",
  "item.minecraft.nether_wart": "bướu nether",
  "item.minecraft.potion": "thuốc không tạo ra được□không có hiệu ứng nào",
  "item.minecraft.glass_bottle": "chai thủy tinh",
  "item.minecraft.spider_eye": "mắt nhện",
  "item.minecraft.fermented_spider_eye": "mắt nhện được lên men",
  "item.minecraft.blaze_powder": "bột quỷ lửa",
  "item.minecraft.magma_cream": "kem dung nham",
  "block.minecraft.brewing_stand": "giàn pha thuốc",
  "block.minecraft.cauldron": "vạc",
  "item.minecraft.ender_eye": "mắt của ender",
  "item.minecraft.glistering_melon_slice": "lát cắt dưa hấu lấp lánh",
  "item.minecraft.bat_spawn_egg": "trứng sinh ra con dơi",
  "item.minecraft.bee_spawn_egg": "trứng sinh ra con ong",
  "item.minecraft.blaze_spawn_egg": "trứng sinh ra quỷ lửa",
  "item.minecraft.cat_spawn_egg": "trứng sinh ra con mèo",
  "item.minecraft.cave_spider_spawn_egg": "trứng sinh ra nhện hang",
  "item.minecraft.chicken_spawn_egg": "trứng sinh ra con gà",
  "item.minecraft.cod_spawn_egg": "trứng sinh ra cá tuyết",
  "item.minecraft.cow_spawn_egg": "trứng sinh ra con bò",
  "item.minecraft.creeper_spawn_egg": "trứng sinh ra creeper",
  "item.minecraft.dolphin_spawn_egg": "trứng sinh ra cá heo",
  "item.minecraft.donkey_spawn_egg": "trứng sinh ra con lừa",
  "item.minecraft.drowned_spawn_egg": "trứng sinh ra kẻ đuối nước",
  "item.minecraft.elder_guardian_spawn_egg": "trứng sinh ra giám hộ cao niên",
  "item.minecraft.enderman_spawn_egg": "trứng sinh ra người ender",
  "item.minecraft.endermite_spawn_egg": "trứng sinh ra rận ender",
  "item.minecraft.evoker_spawn_egg": "trứng sinh ra kẻ chiêu hồn",
  "item.minecraft.fox_spawn_egg": "trứng sinh ra con cáo",
  "item.minecraft.ghast_spawn_egg": "trứng sinh ra ghast",
  "item.minecraft.guardian_spawn_egg": "trứng sinh ra giám hộ",
  "item.minecraft.hoglin_spawn_egg": "trứng sinh ra hoglin",
  "item.minecraft.horse_spawn_egg": "trứng sinh ra con ngựa",
  "item.minecraft.husk_spawn_egg": "trứng sinh ra quái khô tàn",
  "item.minecraft.llama_spawn_egg": "trứng sinh ra lạc đà không bướu",
  "item.minecraft.magma_cube_spawn_egg": "trứng sinh ra khối dung nham",
  "item.minecraft.mooshroom_spawn_egg": "trứng sinh ra mooshroom",
  "item.minecraft.mule_spawn_egg": "trứng sinh ra con la",
  "item.minecraft.ocelot_spawn_egg": "trứng sinh ra mèo rừng",
  "item.minecraft.panda_spawn_egg": "trứng sinh ra gấu trúc",
  "item.minecraft.parrot_spawn_egg": "trứng sinh ra con vẹt",
  "item.minecraft.phantom_spawn_egg": "trứng sinh ra phantom",
  "item.minecraft.pig_spawn_egg": "trứng sinh ra con heo",
  "item.minecraft.piglin_spawn_egg": "trứng sinh ra piglin",
  "item.minecraft.pillager_spawn_egg": "trứng sinh ra kẻ cướp",
  "item.minecraft.polar_bear_spawn_egg": "trứng sinh ra gấu bắc cực",
  "item.minecraft.pufferfish_spawn_egg": "trứng sinh ra cá nóc",
  "item.minecraft.rabbit_spawn_egg": "trứng sinh ra con thỏ",
  "item.minecraft.ravager_spawn_egg": "trứng sinh ra quái thú cướp bóc",
  "item.minecraft.salmon_spawn_egg": "trứng sinh ra cá hồi",
  "item.minecraft.sheep_spawn_egg": "trứng sinh ra con cừu",
  "item.minecraft.shulker_spawn_egg": "trứng sinh ra shulker",
  "item.minecraft.silverfish_spawn_egg": "trứng sinh ra con nhậy bạc",
  "item.minecraft.skeleton_spawn_egg": "trứng sinh ra bộ xương",
  "item.minecraft.skeleton_horse_spawn_egg": "trứng sinh ra ngựa xương",
  "item.minecraft.slime_spawn_egg": "trứng sinh ra quái vật chất nhờn",
  "item.minecraft.spider_spawn_egg": "trứng sinh ra nhện",
  "item.minecraft.squid_spawn_egg": "trứng sinh ra con mực",
  "item.minecraft.stray_spawn_egg": "trứng sinh ra quái lang thang",
  "item.minecraft.strider_spawn_egg": "trứng sinh ra kẻ sải bước",
  "item.minecraft.trader_llama_spawn_egg": "trứng sinh ra lạc đà không bướu của thương nhân",
  "item.minecraft.tropical_fish_spawn_egg": "trứng sinh ra cá nhiệt đới",
  "item.minecraft.turtle_spawn_egg": "trứng sinh ra con rùa",
  "item.minecraft.vex_spawn_egg": "trứng sinh ra hồn ma bay",
  "item.minecraft.villager_spawn_egg": "trứng sinh ra dân làng",
  "item.minecraft.vindicator_spawn_egg": "trứng sinh ra kẻ biện hộ",
  "item.minecraft.wandering_trader_spawn_egg": "trứng sinh ra thương nhân lang thang",
  "item.minecraft.witch_spawn_egg": "trứng sinh ra phù thủy",
  "item.minecraft.wither_skeleton_spawn_egg": "trứng sinh ra bộ xương wither",
  "item.minecraft.wolf_spawn_egg": "trứng sinh ra chó sói",
  "item.minecraft.zoglin_spawn_egg": "trứng sinh ra zoglin",
  "item.minecraft.zombie_spawn_egg": "trứng sinh ra thây ma",
  "item.minecraft.zombie_horse_spawn_egg": "trứng sinh ra ngựa thây ma",
  "item.minecraft.zombie_villager_spawn_egg": "trứng sinh ra dân làng thây ma",
  "item.minecraft.zombified_piglin_spawn_egg": "trứng sinh ra piglin thây ma",
  "item.minecraft.experience_bottle": "chai kinh nghiệm",
  "item.minecraft.fire_charge": "cầu lửa",
  "item.minecraft.writable_book": "sách và bút lông",
  "item.minecraft.written_book": "sách được viết",
  "item.minecraft.emerald": "ngọc lục bảo",
  "item.minecraft.item_frame": "khung vật phẩm",
  "block.minecraft.flower_pot": "chậu hoa",
  "item.minecraft.carrot": "cà rốt",
  "item.minecraft.potato": "khoai tây",
  "item.minecraft.baked_potato": "khoai tây bỏ lò",
  "item.minecraft.poisonous_potato": "khoai tây độc",
  "item.minecraft.map": "bản đồ trống",
  "item.minecraft.golden_carrot": "cà rốt vàng",
  "block.minecraft.skeleton_skull": "đầu lâu bộ xương",
  "block.minecraft.wither_skeleton_skull": "đầu lâu bộ xương wither",
  "block.minecraft.player_head": "đầu người chơi",
  "block.minecraft.zombie_head": "đầu thây ma",
  "block.minecraft.creeper_head": "đầu creeper",
  "block.minecraft.dragon_head": "đầu rồng",
  "item.minecraft.carrot_on_a_stick": "cần câu gắn cà rốt",
  "item.minecraft.warped_fungus_on_a_stick": "cần câu gắn nấm kì dị",
  "item.minecraft.nether_star": "sao nether",
  "item.minecraft.pumpkin_pie": "bánh bí ngô",
  "item.minecraft.firework_rocket": "pháo hoa",
  "item.minecraft.firework_star": "bông pháo hoa",
  "item.minecraft.enchanted_book": "sách được phù phép",
  "item.minecraft.nether_brick": "gạch nether",
  "item.minecraft.quartz": "thạch anh nether",
  "item.minecraft.tnt_minecart": "xe mỏ có tnt",
  "item.minecraft.hopper_minecart": "xe mỏ có phễu",
  "item.minecraft.prismarine_shard": "mảnh lăng trụ biển",
  "item.minecraft.prismarine_crystals": "tinh thể lăng trụ biển",
  "item.minecraft.rabbit": "thịt thỏ sống",
  "item.minecraft.cooked_rabbit": "thịt thỏ chín",
  "item.minecraft.rabbit_stew": "súp thỏ hầm",
  "item.minecraft.rabbit_foot": "chân thỏ",
  "item.minecraft.rabbit_hide": "da thỏ",
  "item.minecraft.armor_stand": "giá để giáp",
  "item.minecraft.iron_horse_armor": "giáp ngựa sắt",
  "item.minecraft.golden_horse_armor": "giáp ngựa vàng",
  "item.minecraft.diamond_horse_armor": "giáp ngựa kim cương",
  "item.minecraft.leather_horse_armor": "giáp ngựa da",
  "item.minecraft.lead": "dây buộc",
  "item.minecraft.name_tag": "nhãn ghi tên",
  "item.minecraft.command_block_minecart": "xe mỏ có khối điều khiển",
  "item.minecraft.mutton": "thịt cừu sống",
  "item.minecraft.cooked_mutton": "thịt cừu chín",
  "block.minecraft.white_banner": "cờ hiệu trắng",
  "block.minecraft.orange_banner": "cờ hiệu cam",
  "block.minecraft.magenta_banner": "cờ hiệu đỏ sậm",
  "block.minecraft.light_blue_banner": "cờ hiệu xanh nước biển nhạt",
  "block.minecraft.yellow_banner": "cờ hiệu vàng",
  "block.minecraft.lime_banner": "cờ hiệu xanh lá mạ",
  "block.minecraft.pink_banner": "cờ hiệu hồng",
  "block.minecraft.gray_banner": "cờ hiệu xám",
  "block.minecraft.light_gray_banner": "cờ hiệu xám nhạt",
  "block.minecraft.cyan_banner": "cờ hiệu lục lam",
  "block.minecraft.purple_banner": "cờ hiệu tím",
  "block.minecraft.blue_banner": "cờ hiệu xanh nước biển",
  "block.minecraft.brown_banner": "cờ hiệu nâu",
  "block.minecraft.green_banner": "cờ hiệu xanh lá cây",
  "block.minecraft.red_banner": "cờ hiệu đỏ",
  "block.minecraft.black_banner": "cờ hiệu đen",
  "item.minecraft.end_crystal": "pha lê end",
  "item.minecraft.chorus_fruit": "quả chorus",
  "item.minecraft.popped_chorus_fruit": "quả chorus nở bung",
  "item.minecraft.beetroot": "củ dền",
  "item.minecraft.beetroot_seeds": "hạt củ dền",
  "item.minecraft.beetroot_soup": "súp củ dền",
  "item.minecraft.dragon_breath": "hơi thở của rồng",
  "item.minecraft.splash_potion": "thuốc không thể tạo ra có thể ném được□không có hiệu ứng nào",
  "item.minecraft.spectral_arrow": "mũi tên ma quỷ",
  "item.minecraft.tipped_arrow": "mũi tên tẩm thuốc không chế tạo được□không có hiệu ứng nào",
  "item.minecraft.lingering_potion": "thuốc không thể tạo ra kéo dài□không có hiệu ứng nào",
  "item.minecraft.shield": "khiên",
  "item.minecraft.elytra": "cánh cứng",
  "item.minecraft.spruce_boat": "thuyền gỗ van sâm",
  "item.minecraft.birch_boat": "thuyền gỗ bạch dương",
  "item.minecraft.jungle_boat": "thuyền gỗ rừng",
  "item.minecraft.acacia_boat": "thuyền gỗ xiêm gai",
  "item.minecraft.dark_oak_boat": "thuyền gỗ sồi sẫm",
  "item.minecraft.totem_of_undying": "vật tổ trường sinh",
  "item.minecraft.shulker_shell": "vỏ shulker",
  "item.minecraft.iron_nugget": "hạt sắt",
  "item.minecraft.knowledge_book": "sách kiến thức",
  "item.minecraft.debug_stick": "gậy gỡ lỗi",
  "item.minecraft.music_disc_13": "đĩa nhạc□c418 - 13",
  "item.minecraft.music_disc_cat": "đĩa nhạc□c418 - cat",
  "item.minecraft.music_disc_blocks": "đĩa nhạc□c418 - blocks",
  "item.minecraft.music_disc_chirp": "đĩa nhạc□c418 - chirp",
  "item.minecraft.music_disc_far": "đĩa nhạc□c418 - far",
  "item.minecraft.music_disc_mall": "đĩa nhạc□c418 - mall",
  "item.minecraft.music_disc_mellohi": "đĩa nhạc□c418 - mellohi",
  "item.minecraft.music_disc_stal": "đĩa nhạc□c418 - stal",
  "item.minecraft.music_disc_strad": "đĩa nhạc□c418 - strad",
  "item.minecraft.music_disc_ward": "đĩa nhạc□c418 - ward",
  "item.minecraft.music_disc_11": "đĩa nhạc□c418 - 11",
  "item.minecraft.music_disc_wait": "đĩa nhạc□c418 - wait",
  "item.minecraft.music_disc_pigstep": "đĩa nhạc□lena raine - pigstep",
  "item.minecraft.trident": "đinh ba□□khi ở trong tay chính:□+8 sức tấn công□-2.9 tốc độ tấn công",
  "item.minecraft.phantom_membrane": "màng da phantom",
  "item.minecraft.nautilus_shell": "vỏ ốc anh vũ",
  "item.minecraft.heart_of_the_sea": "trái tim biển cả",
  "item.minecraft.crossbow": "nỏ",
  "item.minecraft.suspicious_stew": "súp đáng ngờ",
  "block.minecraft.loom": "khung cửi",
  "item.minecraft.flower_banner_pattern": "hoa văn cờ hiệu□phù hiệu hoa",
  "item.minecraft.creeper_banner_pattern": "hoa văn cờ hiệu□phù hiệu creeper",
  "item.minecraft.skull_banner_pattern": "hoa văn cờ hiệu□phù hiệu đầu lâu",
  "item.minecraft.mojang_banner_pattern": "hoa văn cờ hiệu□vật thể",
  "item.minecraft.globe_banner_pattern": "hoa văn cờ hiệu□địa cầu",
  "item.minecraft.piglin_banner_pattern": "hoa văn cờ hiệu□mũi heo",
  "block.minecraft.composter": "thùng ủ phân",
  "block.minecraft.barrel": "thùng",
  "block.minecraft.smoker": "lò hun khói",
  "block.minecraft.blast_furnace": "lò luyện kim",
  "block.minecraft.cartography_table": "bàn vẽ bản đồ",
  "block.minecraft.fletching_table": "bàn làm cung tên",
  "block.minecraft.grindstone": "đá mài",
  "block.minecraft.lectern": "bục để sách",
  "block.minecraft.smithing_table": "bàn rèn",
  "block.minecraft.stonecutter": "máy cắt đá",
  "block.minecraft.bell": "chuông",
  "block.minecraft.lantern": "đèn lồng",
  "block.minecraft.soul_lantern": "đèn linh hồn",
  "item.minecraft.sweet_berries": "quả mọng ngọt",
  "block.minecraft.campfire": "lửa trại",
  "block.minecraft.soul_campfire": "lửa trại linh hồn",
  "block.minecraft.shroomlight": "đèn nấm",
  "item.minecraft.honeycomb": "sáp ong",
  "block.minecraft.bee_nest": "tổ ong tự nhiên",
  "block.minecraft.beehive": "tổ ong nhân tạo",
  "item.minecraft.honey_bottle": "chai mật ong",
  "block.minecraft.honey_block": "khối mật ong",
  "block.minecraft.honeycomb_block": "khối sáp ong",
  "block.minecraft.lodestone": "đá nam châm",
  "block.minecraft.netherite_block": "khối netherit",
  "block.minecraft.ancient_debris": "mảnh vỡ cổ đại",
  "block.minecraft.target": "bia bắn",
  "block.minecraft.crying_obsidian": "hắc diện thạch khóc",
  "block.minecraft.blackstone": "đá đen",
  "block.minecraft.blackstone_slab": "phiến đá đen",
  "block.minecraft.blackstone_stairs": "cầu thang đá đen",
  "block.minecraft.gilded_blackstone": "đá đen mạ vàng",
  "block.minecraft.polished_blackstone": "đá đen được đánh bóng",
  "block.minecraft.polished_blackstone_slab": "phiến đá đen được đánh bóng",
  "block.minecraft.polished_blackstone_stairs": "cầu thang đá đen được đánh bóng",
  "block.minecraft.chiseled_polished_blackstone": "đá đen được đánh bóng được đục",
  "block.minecraft.polished_blackstone_bricks": "gạch đá đen được đánh bóng",
  "block.minecraft.polished_blackstone_brick_slab": "phiến gạch đá đen được đánh bóng",
  "block.minecraft.polished_blackstone_brick_stairs": "cầu thang gạch đá đen được đánh bóng",
  "block.minecraft.cracked_polished_blackstone_bricks": "gạch đá đen được đánh bóng nứt",
  "block.minecraft.respawn_anchor": "neo hồi sinh",
}
export const vi_vn = items; 
